import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-manage-subtype',
  templateUrl: './manage-subtype.component.html',
  styleUrls: ['./manage-subtype.component.scss']
})

export class ManageSubtypeComponent implements OnInit {
  getAllTypesVm = {
    userID: "",
    databaseID: 0,
    organizationId: 0,
    PageIndex: 0,
    PageSize: 10,
    searchValue: '',
    FolderID: [],
    OfficeIDList:[],
    officeID: 0,
  };
  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };
  CheckTypeVM = {
    databaseID: 0,
    organizationId: 0,
    SubFolderID: 0,
    officeID:0,
    OfficeIDList:[]
  };
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  responseHolder: any;
  typeListActive: any;
  typeListInactive: any;
  value = '';
  filterText: any;  
  paginatorTotalLength: any;  
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;
  editType = {
    ParentID: 0,
    FolderID: 0,
    folderName: "",
    isActive: false,
    UserId: "",
    DatabaseID: 0,
    organizationId: sessionStorage.getItem('organizationID')
  }
  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService, private toastr: ToastrService,
     private statusConst: StatusConstant, private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }
  

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('subtype',this.formBuilder.control(''));
    this.formDialog.addControl('active', this.formBuilder.control(''));
    this.getTypeList(this.pageModelData);
  }

  openDialogWithRef(templateRef: TemplateRef<any>, type: any) {
    this.editType.ParentID = type.folderID;
    this.editType.FolderID = type.subFolderID;
    this.editType.folderName = type.subFolderName;
    this.editType.isActive = type.isActive;
    this.dialog.open(templateRef, {
    });
    this.formDialog.markAsPristine();
  }

  getTypeList(pageData: any) {
    this.loaderService.show();
    this.getAllTypesVm.userID = this.currentUser.UID;
    this.getAllTypesVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getAllTypesVm.organizationId = Number(this.organizationId);
    this.getAllTypesVm.PageIndex = pageData.pageIndex;
    this.getAllTypesVm.PageSize = pageData.pageSize;
    this.getAllTypesVm.searchValue = pageData.searchValue;
    this.getAllTypesVm.OfficeIDList=this.OfficeIDList;
    this.getAllTypesVm.officeID = this.myOfficeID;
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    this.settingsService.getAllTypes(this.getAllTypesVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.typeListActive = this.responseHolder.data.activeTypes;
          this.paginatorTotalLength = this.responseHolder.data.totalCount;
          this.pageModelData.pageIndex = this.responseHolder.data.pageIndex;
          this.pageIndex = this.responseHolder.data.pageIndex;
          this.pageSize = pageData.pageSize;
          if(this.typeListActive.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }  
          this.loaderService.hide();
        }
        else {
          this.ShowNoRecordFound=true;
          this.typeListActive=[];
          this.paginatorTotalLength=0;
          this.loaderService.hide();
        }
      }
      else {
          this.ShowNoRecordFound=true;
          this.typeListActive=[];
          this.paginatorTotalLength=0;
          this.loaderService.hide();
      }
    });
  }

  spinner:boolean=false;

  UpdateTypeDetails() {
    this.spinner=true;
    this.formDialog.markAsPristine();
    let type = this.editType;
    this.loaderService.show();
    var ReqModel = {
      ParentID: type.ParentID,
      FolderID: type.FolderID,
      folderName: type.folderName,
      isActive: type.isActive,
      UserId: this.currentUser.UID,
      DatabaseID: parseInt(sessionStorage.getItem('databaseId')),
      OrganizationID:  parseInt(sessionStorage.getItem('organizationID')),
      OfficeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
    }
    this.settingsService.updateType(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;
        this.responseHolder = response;
        if (this.responseHolder.data == true) {
          this.dialog.closeAll();
          this.toastr.success('Name updated successfully.', '', {
            timeOut: 3000,
          });
          this.getTypeList(this.pageModelData);
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }

  UpdateType(type: any, event: any) {
    this.loaderService.show();
    var ReqModel = {
      ParentID: type.folderID,
      FolderID: type.subFolderID,
      folderName: type.subFolderName,
      isActive: event.checked,
      UserId: this.currentUser.UID,
      DatabaseID: parseInt(sessionStorage.getItem('databaseId')),
      OrganizationID:  parseInt(sessionStorage.getItem('organizationID')),
      OfficeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
    }
     this.settingsService.updateType(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.data == true) {
          this.toastr.success('Status updated successfully.', '', {
            timeOut: 3000,
          });
          this.getTypeList(this.pageModelData);
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }



  checkIfTypeExists(type: any) {  
    let check=false;
    this.CheckTypeVM.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.CheckTypeVM.organizationId = Number(this.organizationId);
    this.CheckTypeVM.SubFolderID= Number(type.subFolderID);
    this.CheckTypeVM.officeID=this.myOfficeID;
    this.CheckTypeVM.OfficeIDList=this.OfficeIDList;
    this.settingsService.checkIfTypeExists(this.CheckTypeVM).subscribe(response => {
    this.responseHolder = response;
    check= this.responseHolder.data;
      if(check){ 
        this.toastr.error("Can't delete as used in transactions.", '', {
          timeOut: 1000,
        });
      }     
    else{
    
      var message;
      message = `Are you sure you want to delete?`;  
      const title = `Confirm Delete`;
      const confirm = `Delete`;
      const dialogData = new ConfirmDialogModel(title, message,confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData
      });
  
      dialogRef.beforeClosed().subscribe(async dialogResult => {
        if (dialogResult) {
          this.loaderService.show();
          let pageData = this.pageModelData;
          this.getAllTypesVm.userID = this.currentUser.UID;
          this.getAllTypesVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
          this.getAllTypesVm.organizationId = Number(this.organizationId);
          this.getAllTypesVm.FolderID.push(type.subFolderID);
          this.getAllTypesVm.PageIndex = pageData.pageIndex;
          this.getAllTypesVm.PageSize = pageData.pageSize;
          this.getAllTypesVm.searchValue = pageData.searchValue.trim();
          this.getAllTypesVm.officeID=this.myOfficeID;
          this.getAllTypesVm.OfficeIDList=this.OfficeIDList;
          this.settingsService.deleteTypes(this.getAllTypesVm).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.data == 1) {
                this.toastr.success('SubType deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.getTypeList(this.pageModelData);
                this.loaderService.hide();
              }else{
                this.loaderService.hide();
              }
            }else{
              this.loaderService.hide();
            }
          });
        }
      });
     }
    });
    return check;
  }
  
  changedToggle(type: any, event: any) {
  }

  close() {
    this.dialog.closeAll();
  }

  Search(filterValue) {
    this.filterText = filterValue.trimLeft();
    this.pageModelData.searchValue = filterValue.trim();
    this.getTypeList(this.pageModelData);
  }

  clearFilter(){
    this.value = "";
    this.filterText = "";
    this.pageModelData.searchValue = this.filterText.trim();
    this.getTypeList(this.pageModelData);
  }

  CallNextPrevPageData(pageData: PageEvent) {
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue = this.value.trim();
    this.getTypeList(this.pageModelData);
  }

}
